const MEDIA_ITEMS = [
  {
    title: '韩漫推荐：不可错过的十大热门连载',
    type: '编辑推荐',
    views: '12.8万',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20manga%20themed%20thumbnail%20with%20Korean%20comic%20style%20decorative%20elements%2C%20warm%20peach%20and%20cream%20gradient%20background%2C%20clean%20minimal%20design%2C%20soft%20lighting%2C%20artistic%20composition%2C%20video%20thumbnail%20aesthetic%2C%20harmonious%20color%20palette&width=800&height=450&seq=media-kr-recommend&orientation=landscape',
  },
  {
    title: '国漫崛起进行时：古风佳作精选',
    type: '专题策划',
    views: '9.6万',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20with%20ancient%20Chinese%20art%20motifs%2C%20flowing%20ink%20wash%20elements%2C%20warm%20peach%20and%20cream%20tones%2C%20soft%20dreamy%20atmosphere%2C%20clean%20minimal%20design%2C%20artistic%20composition%2C%20harmonious%20color%20palette&width=800&height=450&seq=media-cn-feature&orientation=landscape',
  },
  {
    title: '下拉式追更教程：如何获得最佳阅读体验',
    type: '使用指南',
    views: '8.3万',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20smartphone%20displaying%20scrolling%20comic%20content%2C%20warm%20cream%20and%20peach%20gradient%20background%2C%20clean%20modern%20UI%20mockup%20style%2C%20soft%20ambient%20lighting%2C%20minimal%20design%2C%20harmonious%20composition&width=800&height=450&seq=media-reading-guide&orientation=landscape',
  },
  {
    title: '日漫治愈系：温暖你心灵的十部漫画',
    type: '编辑精选',
    views: '11.2万',
    image: 'https://readdy.ai/api/search-image?query=A%20gentle%20warm%20illustration%20with%20Japanese%20aesthetic%20elements%2C%20soft%20cherry%20blossom%20petals%2C%20warm%20peach%20and%20cream%20tones%2C%20cozy%20atmosphere%2C%20clean%20minimal%20design%2C%20stylized%20anime%20art%20influence%2C%20harmonious%20composition&width=800&height=450&seq=media-jp-healing&orientation=landscape',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            编辑精心制作的漫画推荐与阅读指南，帮助你发现更多好作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`香香漫画 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-xl text-primary-600 group-hover:text-background-50 transition-colors ml-0.5" />
                  </div>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-accent-600 font-medium">{item.type}</span>
                  <span className="text-xs text-foreground-400">{item.views} 次浏览</span>
                </div>
                <h3 className="mt-2 text-sm font-semibold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}